import React, { useCallback, useState ,useEffect} from "react";
import { PieChart, Pie, Sector, Cell,ResponsiveContainer } from "recharts";
import { useDataContext } from "../../context/DataContext";
import { losColor } from "../../../../constants/scoreScale";

import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

export default function Los({nodeId, selectedScenarioLos}) {
    const [data, setDataJson] = useState([]);
    const [activeIndex, setActiveIndex] = useState(0);

    // Use DataContext for client-specific data (default or lavagna)
    const { losDataJson, dataLoaded } = useDataContext();

    useEffect(() => {
        if (dataLoaded && losDataJson && selectedScenarioLos) {
            const selectedScenario = losDataJson.scenario?.find(scenario => scenario.replicaAvg === selectedScenarioLos);
            if (selectedScenario) {
                setDataJson(selectedScenario.LosNodi);
                console.log('Los updated with scenario:', selectedScenario.LosNodi);
            } else {
                setDataJson([]);
            }
        }
    }, [selectedScenarioLos, losDataJson, dataLoaded]);

    // Extracting losNodeText and losNodeBgColor based on the selected node
    const selectedNode = data.find(node => node.idNodo === nodeId);
    const losNodeText = selectedNode ? selectedNode.losNode : "";
    const losNodeBgColor = selectedNode ? losColor(selectedNode.losNode, selectedNode.color || "#000") : "#000";

    const renderActiveShape = (nodeId) => (props) => {
        const RADIAN = Math.PI / 180;
        const {
            cx,
            cy,
            midAngle,
            innerRadius,
            outerRadius,
            startAngle,
            endAngle,
            fill,
            payload,
        } = props;

        const sin = Math.sin(-RADIAN * midAngle);
        const cos = Math.cos(-RADIAN * midAngle);
        const sx = cx + (outerRadius + 10) * cos;
        const sy = cy + (outerRadius + 15) * sin;
        const mx = cx + (outerRadius + 10) * cos;
        const my = cy + (outerRadius + 45) * sin;
        const ex = mx + (cos >= 0 ? 1 : -1) * 35;
        const ey = my;
        const textAnchor = cos >= 0 ? "start" : "end";

        const circleRadius = 45;
        const losNodeTextFontSize = 50;
        const losNodeTextFill = "black";

        return (
            <>
                <circle
                    cx={cx}
                    cy={cy}
                    r={circleRadius}
                    fill={losNodeBgColor}
                />
                <text
                    x="45%"
                    y="54%"
                    textAnchor="middle"
                    fontSize={losNodeTextFontSize}
                    fill={losNodeTextFill}
                >
                    {losNodeText}
                </text>
                <Sector
                    cx={cx}
                    cy={cy}
                    innerRadius={innerRadius}
                    outerRadius={outerRadius}
                    startAngle={startAngle}
                    endAngle={endAngle}
                    fill={payload.color}
                />
                <Sector
                    cx={cx}
                    cy={cy}
                    startAngle={startAngle}
                    endAngle={endAngle}
                    innerRadius={outerRadius + 6}
                    outerRadius={outerRadius + 10}
                    fill={payload.color}
                />
                <path
                    d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`}
                    stroke={payload.color}
                    fill="none"
                />
                <circle cx={ex} cy={ey} r={5} fill={fill} stroke="none" />
                <text
                    x={ex + (cos >= 0 ? 1 : -1) * 12}
                    y={ey}
                    textAnchor={textAnchor}
                    fill="#333"
                >{payload.name}</text>
                <text
                    x={ex + (cos >= 0 ? 1 : -1) * 12}
                    y={ey}
                    dy={15}
                    textAnchor={textAnchor}
                    fill="#999"
                >
                </text>
            </>
        );
    };

    const filteredPieChartData = Array.isArray(data) ? data.reduce((acc, node) => {
        if (node.idNodo === nodeId) {
            acc.push(...Object.values(node.sezioni).map((section) => ({
                name: section.losSec || "Unnamed Section",
                ampiezza: section.ampiezza,
                color: losColor(section.losSec, section.color),
                delay: section.delaySec,
                count: section.count,
                nomeVia: section.nomeSec || "No Name"
            })));
        }
        return acc;
    }, []) : [];

    const onPieEnter = useCallback(
        (_, index) => {
            setActiveIndex(index);
        },
        [setActiveIndex]
    );

    return (
        <div className="pie-container-confronto" style={{ height: "100%", width: "100%" }}>


            <div className="content-wrapper-confronto">
                <div className="content-text-confronto" style={{ display: 'flex', flexDirection: 'column', gap: '15px', justifyContent: 'center', alignItems: 'center', width: '50%' }}>

<Box sx={{ display: 'flex', alignItems: 'center', width: 300 }}>
    <TextField
        id="outlined-basic"
        label="Intersezione"
        variant="outlined"
        fullWidth
        multiline
        rows={3}
        InputProps={{
            readOnly: true,
            startAdornment: (
                <Box
                    sx={{
                        backgroundColor: losNodeBgColor,
                        borderRadius: '50%',
                        width: 24,
                        height: 24,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginRight: 1,
                    }}
                >
                    <Typography variant="body2" color="black" sx={{ fontWeight: 'bold' }}>
                        {losNodeText}
                    </Typography>
                </Box>
            ),
        }}
        sx={{
            '& .MuiOutlinedInput-root': {
                '& fieldset': {
                    borderColor: losNodeBgColor || '',
                    borderWidth: '2px',
                    borderRadius: '12px',
                },
                '&:hover fieldset': {
                    borderColor: losNodeBgColor,
                },
                '&.Mui-focused fieldset': {
                    borderColor: losNodeBgColor,
                },
            },

            //colore label text 
            '& .MuiInputLabel-root': {
                color: '#1e7751',
            },
            '& .MuiInputLabel-root.Mui-focused': {
                color: losNodeBgColor,
            },
            width: 300

        }}
    />

    
</Box>

<Box sx={{ display: 'flex', alignItems: 'center', width: 300 }}>
    <TextField
        id="outlined-basic-2"
        label="Sezione"
        variant="outlined"
        fullWidth
        InputProps={{
            readOnly: true,
            startAdornment: (
                <Box
                    sx={{
                        backgroundColor: filteredPieChartData[activeIndex]?.color || '',
                        borderRadius: '50%',
                        width: 24,
                        height: 24,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginRight: 1,
                    }}
                >
                    <Typography variant="body2" color="black" sx={{ fontWeight: 'bold' }}>
                        {filteredPieChartData[activeIndex]?.name || "B"}
                    </Typography>
                </Box>
            ),
        }}
        value={`Ritardo: ${filteredPieChartData[activeIndex]?.delay || "12.8"}\nVeicoli: ${filteredPieChartData[activeIndex]?.count || "22"}\n${filteredPieChartData[activeIndex]?.nomeVia || "Rotatoria – Via Lombardia"}`}
        multiline
        rows={4}
        sx={{
            '& .MuiOutlinedInput-root': {
                '& fieldset': {
                    borderColor: filteredPieChartData[activeIndex]?.color || '',
                    borderWidth: '2px',
                    borderRadius: '12px',
                },
                '&:hover fieldset': {
                    borderColor: filteredPieChartData[activeIndex]?.color || '',
                },
                '&.Mui-focused fieldset': {
                    borderColor: filteredPieChartData[activeIndex]?.color || '',
                },
            },
            '& .MuiInputLabel-root': {
                color: '#1e7751',
            },
            '& .MuiInputLabel-root.Mui-focused': {
                color: filteredPieChartData[activeIndex]?.color || '',
            },
            width: 300
        }}
    />
</Box>

                </div>

                <div className="pie-chart-confronto">
                    <ResponsiveContainer width="100%" height="100%">
                        <PieChart>
                            <Pie
                                activeIndex={activeIndex}
                                activeShape={renderActiveShape(nodeId)}
                                data={filteredPieChartData}
                                cx="45%"
                                cy="50%"
                                innerRadius={51}
                                outerRadius={64}
                                dataKey="ampiezza"
                                paddingAngle={2}
                                onMouseEnter={onPieEnter}
                                onClick={onPieEnter}
                                className="pie-cambia-confronto"
                            >
                                {filteredPieChartData.map((entry, index) => (
                                    <Cell key={`cell-${index}`} fill={entry.color} />
                                ))}
                            </Pie>
                        </PieChart>
                    </ResponsiveContainer>
                </div>
            </div>
        </div>
    );
}
